import React, { useEffect } from "react";
import cn from "classnames";
import moment from 'moment';
import Select from "components/ui/Select";
import { TimeTypes } from "models/DateTime";

import "styles/ui/time-input.scss";

const timeOptions = (minutes, isToday) => {
  const date = new Date();
  let hourNow = date.getHours();
  let minutesNow = date.getMinutes();

  const times = Array.from(
    {
      length: (24 * 60) / minutes
    },
    (v, i) => {
      let h = Math.floor((i * minutes) / 60);
      let m = i * minutes - h * 60;
      if (m < 10) {
        m = "0" + m;
      }
      if (isToday && (h < hourNow || (h === hourNow && m < minutesNow))) {
        return null;
      }
      return h + ":" + m;
    }
  );

  return times.filter(x => x); // remove null values
}

const TimeInput = ({ dateTime, selectedDate, onTimeChange, onTimeTypeChange, isReturn }) => {
  const selectedDateMoment = moment(selectedDate);
  const now = moment();

  const isToday = !selectedDate || selectedDateMoment.isSame(now, 'date');

  const timeIsInThePast = moment().isAfter(moment(dateTime.dateTime), 'minute');

  const timeSelectOptions = timeOptions(15, isToday).map(time => ({ label: time, value: time }));

  const departingNowOption = isReturn ? [] : [{ value: TimeTypes.DEPART_NOW, label: "Now" }];

  useEffect(() => {
    if (timeIsInThePast) {
      onTimeChange(TimeTypes.DEPART_NOW);
    }
  }, [timeIsInThePast, onTimeChange]);

  return (
    <div
      className={cn("otrl-jp__time-input-container", {
        "otrl-jp__time-input-container--time-type": true //!dateTime.isDepartingNow()
      })}
    >
      <Select
        name="timeType"
        className="otrl-jp__time-input"
        onChange={onTimeTypeChange}
        options={[
          { value: TimeTypes.LEAVING_AT, label: "Leaving at" },
          { value: TimeTypes.ARRIVING_AT, label: "Arriving at" }
        ]}
        value={dateTime.getTimeType()}
      />
      <Select
        name="time"
        className={cn("otrl-jp__time-input", "otrl-jp__time-input--hour-minute")}
        // disabled={isDepartingNow}
        onChange={onTimeChange}
        options={[...departingNowOption, ...timeSelectOptions]}
        value={dateTime.isDepartingNow() ? "Depart now" : dateTime.getTimeString()}
      />
    </div>
  );
};

export default TimeInput;
